import { useCurrentSubscription } from '@api/hooks/useSubscription';

export default function UsageBar() {
  const { data: subscription } = useCurrentSubscription();

  if (!subscription) return null;

  const docUsage = subscription.usage.find(
    (u) => u.resource_type === 'documents_processed',
  );
  if (!docUsage) return null;

  const count = docUsage.count;
  const limit = docUsage.limit;
  const isUnlimited = limit === null || limit < 0;
  const percentage = isUnlimited ? 0 : Math.min((count / limit) * 100, 100);
  const isWarning = !isUnlimited && percentage >= 80;
  const isCritical = !isUnlimited && percentage >= 95;

  return (
    <div className="rounded-lg border border-border-subtle bg-surface-base p-4">
      <div className="flex items-center justify-between text-sm">
        <span className="text-content-secondary">Documents this month</span>
        <span className="font-medium text-content-primary">
          {count}
          {isUnlimited ? '' : ` / ${limit}`}
        </span>
      </div>
      {!isUnlimited && (
        <div className="mt-2 h-2 rounded-full bg-surface-raised overflow-hidden">
          <div
            className={`h-full rounded-full transition-all ${
              isCritical
                ? 'bg-red-500'
                : isWarning
                  ? 'bg-amber-500'
                  : 'bg-primary-500'
            }`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      )}
      {isCritical && (
        <p className="mt-2 text-xs text-amber-500">
          Running low on documents.{' '}
          <a
            href="https://ez-flow.io/pricing"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-amber-400"
          >
            Upgrade your plan
          </a>
        </p>
      )}
    </div>
  );
}
